import { sanitizeHtml } from '@thoughtspot/radiant-react/widgets/_utils';
import { Key } from 'w3c-keys';

export const navigationalKeys = new Set<string>([
    Key.ArrowUp,
    Key.ArrowDown,
    Key.ArrowLeft,
    Key.ArrowRight,
    Key.Up,
    Key.Down,
    Key.Left,
    Key.Right,
]);

export function isUp(evt: KeyboardEvent): boolean {
    return evt.key === Key.ArrowUp || evt.key === Key.Up;
}

export function isDown(evt: KeyboardEvent): boolean {
    return evt.key === Key.ArrowDown || evt.key === Key.Down;
}

export function isLeft(evt: KeyboardEvent): boolean {
    return evt.key === Key.ArrowLeft || evt.key === Key.Left;
}

export function isRight(evt: KeyboardEvent): boolean {
    return evt.key === Key.ArrowRight || evt.key === Key.Right;
}

export function isNavigational(evt: KeyboardEvent): boolean {
    return navigationalKeys.has(evt.key);
}

export function isDeletionType(evt: KeyboardEvent): boolean {
    return evt.key === Key.Delete || evt.key === Key.Backspace;
}

export const onBlurHandler = (evt: React.FocusEvent, callback: any) => {
    const currentTarget = evt.currentTarget;
    // Check the newly focused element in the next tick of the event loop
    setTimeout(() => {
        // Check if the new activeElement is a child of the original container
        if (!currentTarget.contains(document.activeElement)) {
            if (callback && typeof callback === 'function') callback();
        }
    }, 0);
};

/**
 * A higher-order function that creates an event handler for sanitizing input
 * when an input or textarea element loses focus.
 *
 * @param cb - Callback function that receives the sanitized input value.
 * @param sanitizeInput - Boolean flag indicating whether to sanitize the input.
 * @returns React FocusEvent handler function.
 * Example: const onNameBlur = onSanitizeBlur(setName, true);
 */
export const onSanitizeBlur = (
    cb: (val: string) => void,
    sanitizeInput: boolean,
) => {
    return (
        event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        if (event.target.value && sanitizeInput) {
            cb(sanitizeHtml(event.target.value).trim());
        }
    };
};
